// Module-level cache for admin image overrides.
// Fetched once per page load; hook subscribes to updates.
import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../App";

let _cache = null;      // { key: url }
let _promise = null;    // in-flight fetch
const _listeners = new Set();

async function _load() {
  if (_cache) return _cache;
  if (_promise) return _promise;
  _promise = axios.get(`${API}/images/overrides`)
    .then((r) => {
      _cache = r.data?.map || {};
      return _cache;
    })
    .catch(() => {
      _cache = {};
      return _cache;
    })
    .finally(() => { _promise = null; });
  return _promise;
}

export function useImageOverrides() {
  const [map, setMap] = useState(_cache || {});
  useEffect(() => {
    let alive = true;
    _load().then((m) => { if (alive) setMap(m); });
    const on = (m) => { if (alive) setMap({ ...m }); };
    _listeners.add(on);
    return () => { alive = false; _listeners.delete(on); };
  }, []);
  return map;
}

// Resolve a normalized image URL.
// key = stable slot key (e.g. "q_texture_straight" or "gender_woman" or "welcome_hero")
// fallback = default hardcoded image URL
export function resolveImage(map, key, fallback) {
  const u = map && map[key];
  if (!u) return fallback;
  // Backend returns paths like /api/images/file/<path>. Make it absolute against REACT_APP_BACKEND_URL.
  if (u.startsWith("/api/")) {
    const base = process.env.REACT_APP_BACKEND_URL || "";
    return `${base}${u}`;
  }
  return u;
}

// Force a refresh (called from admin page after uploads).
export function refreshImageOverrides() {
  _cache = null;
  return _load().then((m) => { _listeners.forEach((cb) => cb(m)); return m; });
}
